import { render, staticRenderFns } from "./companyList.vue?vue&type=template&id=0fbf0075&scoped=true&"
import script from "./companyList.vue?vue&type=script&lang=js&"
export * from "./companyList.vue?vue&type=script&lang=js&"
import style0 from "../statistics/css/companyList.css?vue&type=style&index=0&id=0fbf0075&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf0075",
  null
  
)

export default component.exports